import { Controller } from '@hotwired/stimulus'
import { useClickOutside } from 'stimulus-use'
import { computePosition, flip, offset, shift } from '@floating-ui/dom'

import './dropdown_component.scss'
import { uncloak } from '@/utils/component'

export default class extends Controller {
  static targets = ['menu']
  static values = { placement: String }

  connect() {
    useClickOutside(this)
    uncloak(this.element)
  }

  clickOutside() {
    this.hide()
  }

  toggle() {
    if (this.shown) {
      this.hide()
    } else {
      this.show()
    }
  }

  show() {
    this.menuTarget.style.display = 'block'
    this.computePosition()
  }

  hide() {
    this.menuTarget.style.display = null
  }

  preventHide(event) {
    event.stopPropagation()
  }

  computePosition() {
    computePosition(this.element, this.menuTarget, {
      placement: this.placement,
      middleware: [offset(0), flip(), shift({ padding: 5 })]
    }).then(({ x, y }) => {
      Object.assign(this.menuTarget.style, {
        left: `${x}px`,
        top: `${y}px`
      })
    })
  }

  get shown() {
    return this.menuTarget.style.display === 'block'
  }

  get placement() {
    if (this.placementValue === 'right') {
      return 'bottom-end'
    } else {
      return 'bottom-start'
    }
  }
}
